import publicAppsClient from "../middleware/publicAppsClient";

export const REGISTRATION_CONFIG_ENDPOINT = "registration-config";
export const REGISTER_ENDPOINT = "register";
export const SEND_OTP_ENDPOINT = "phone/send-otp";
export const VERIFY_OTP_ENDPOINT = "phone/verify-otp";

export async function fetchRegistrationConfig() {
  const response = await publicAppsClient.get(REGISTRATION_CONFIG_ENDPOINT);
  return response.data;
}

export async function registerPlayer(payload) {
  const response = await publicAppsClient.post(REGISTER_ENDPOINT, payload);
  return response.data;
}

export async function sendRegisterOtp(payload) {
  const response = await publicAppsClient.post(SEND_OTP_ENDPOINT, payload);
  return response.data;
}

export async function verifyRegisterOtp(payload) {
  const response = await publicAppsClient.post(VERIFY_OTP_ENDPOINT, payload);
  return response.data;
}
